import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { createPath } from 'history'

const useBlockBackNavigation = (active: boolean = true) => {
  const history = useHistory()

  useEffect(() => {
    if (!active) return

    return history.block((location, action) => {
      if (action !== 'POP') return undefined

      // history@4 rebuilds its key list on every page load, so after a refresh its
      // revertPop() computes delta 0 and leaves the URL on the popped entry while the
      // router still renders this one. Restore the URL ourselves.
      if (createPath(location) !== createPath(history.location)) window.history.go(1)

      return false
    })
  }, [history, active])
}

export default useBlockBackNavigation
